export default __webpack_public_path__ + "static/media/facebook.9ff3a2fe.svg";